/**
 * Size of the screen where the menu is changed to collapsed state (by css).
 * @type {number}
 */
export const MENU_AUTO_COLLAPSING_WIDTH = 1150
